module.exports = __webpack_public_path__ + "img/s2.9753098d.png";